meedy.factory('meedy.invoiceService', ['$q', '$translate', '$http', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function ($q, $translate, $http, baseService, objectHelper, config) {

        function InvoiceService() {

            this.getInvoices = function (criteria) {
                var d = $q.defer();

                var _criteria = objectHelper.convertDatesToTimes(criteria);
                baseService.post(config.API_URL + '/invoices/getInvoices', _criteria).then(
                    function (successResponse) {
                        var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
                        dataPage.data = objectHelper.translateArray(dataPage.data, MedicalPostInvoiceMeedyVO);

                        d.resolve(dataPage);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

            this.getDownloadToken = function (idInvoice, fileType) {
                var d = $q.defer();

                baseService.post(config.API_URL + '/invoices/getDownloadToken/' + idInvoice, fileType).then(
                    function (token) {
                        d.resolve(token);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

            this.getInvoicesWaitingForAcceptation = function () {
                var d = $q.defer();

                baseService.post(config.API_URL + '/invoices/getInvoicesWaitingForAcceptation/').then(
                    function (token) {
                        d.resolve(token);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

            this.updateInvoice = function (invoice) {
                var d = $q.defer();

                baseService.post(config.API_URL + '/invoices/updateInvoice', invoice).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, MedicalPostInvoiceMeedyVO);
                        d.resolve(data);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

            this.download = function (token, fileType) {
                var d = $q.defer();

                $http({
                    url :  config.API_URL + '/invoices/download/' + token,
                    method : 'GET',
                    params : {},
                    headers : {
                        'Content-type' : 'application/pdf'
                    },
                    responseType : 'arraybuffer'
                }).success(function(data, status, headers, config) {
                    var file = undefined;

                    if(fileType.generatedFileType == Enum.MEEDY.GENERATED_FILE_TYPE.INVOICE) {
                        file = new Blob([ data ], {
                            type : 'application/pdf'
                        });
                    } else if (fileType.generatedFileType == Enum.MEEDY.GENERATED_FILE_TYPE.INVOICE_XLS) {
                        file = new Blob([ data ], {
                            type : 'application/vnd.ms-excel'
                        });
                    }
                    //trick to download store a file having its URL

                    var fileURL = URL.createObjectURL(file);
                    var a         = document.createElement('a');
                    a.href        = fileURL;
                    a.target      = '_blank';
                    a.download    = 'Faktura';

                    document.body.appendChild(a);
                    a.click();

                    d.resolve(data);
                }).error(function(data, status, headers, config) {
                    d.reject(data);
                });

                return d.promise;
            };

        }

        return new InvoiceService();
    }
]);
